import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import CheckinReportModel from '../../../models/CheckinReportModel';
import moment from 'moment';

export default async function getGuestSchedulesPass(
  eventId = '',
  offset = 0,
  limit = 10,
  guestId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/report/getGuestSchedulesPass?eventId=${eventId}&offset=${offset}&limit=${limit}`
        + (guestId ? `&guestId=${guestId}` : ''),
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: _ret.data.data.count,
    };
    for (let i = 0; i < _ret.data.data.data.length; i++) {
      const _item = _ret.data.data.data[i];
      _return.data.push(CheckinReportModel({
        id: _item.id,
        nome: _item.nome,
        email: _item.Email,
        dataRegistro: moment(_item.DataRegistro).add(3, 'hours').format('DD/MM/YYYY HH:mm'),
        tituloProgramacao: _item.TituloProgramacao,
      }));
    }
    return _return;
  } catch (error) {
    console.log('Error getGuestSchedulesPass', error);
    throw error;
  }
}
